// Returns the userAgent
export const userAgent = () => window.navigator.userAgent;

// Performs a simple userAgent parse to determine the device os
export const os = () => (userAgent().match(/(iPad|iPhone|iPod)/gi) ? "ios" : "android");

export const getOsAndVersion = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  let os = "Unknown OS";
  let version = "";

  // iOS detection
  if (/iPhone|iPad|iPod/i.test(userAgent)) {
    os = "iOS";
    const versionMatch = userAgent.match(/OS (\d+_\d+)/i);
    if (versionMatch) {
      version = versionMatch[1].replace("_", ".");
    }
  }

  // Android detection
  else if (/android/i.test(userAgent)) {
    os = "Android";
    const versionMatch = userAgent.match(/Android\s([0-9.]*)/);
    if (versionMatch) {
      version = versionMatch[1];
    }
  }

  // Windows detection
  else if (/Win/i.test(userAgent)) {
    os = "Windows";
    const versionMatch = userAgent.match(/Windows NT ([0-9.]+)/);
    if (versionMatch) {
      const ntVersion = versionMatch[1];
      switch (ntVersion) {
        case "10.0":
          version = "10";
          break;
        case "6.3":
          version = "8.1";
          break;
        case "6.2":
          version = "8";
          break;
        case "6.1":
          version = "7";
          break;
        case "6.0":
          version = "Vista";
          break;
        case "5.1":
          version = "XP";
          break;
        default:
          version = ntVersion;
      }
    }
  }

  // MacOS detection
  else if (/Mac/i.test(userAgent)) {
    os = "MacOS";
    const versionMatch = userAgent.match(/Mac OS X ([0-9_]+)/);
    if (versionMatch) {
      version = versionMatch[1].replace(/_/g, ".");
    }
  }

  // Linux detection
  else if (/Linux/i.test(userAgent)) {
    os = "Linux";
  }

  return `${os} ${version}`.trim();
};
export const client = { os, userAgent };
